const tr = {
    en: {
        successTitle: "Success!",
        success: "You\u2019re all set. Enjoy your subscription from {{brand}} {{mobileNum}}.",

        saveCheckboxTxt: "Save my mobile number to pay for future purchase through 1O1O/csl/Club Sim mobile bill.",

        continueBtnTxt: "OK",

        noPackSuccessTitle: "Success!",
        noPackSuccess: "Your {{brand}} account {{mobileNum}} has been set up.",
        noPackBePatient: " There are no active subscriptions to Now E. ",
        noPackHelpHotline: "Need help? Please call {{brand}} customer service at {{hotLine}} and we\u2019ll get things sorted. Thanks!",

    },
    zh: {
        successTitle: "完成！",
        success: "已完成設定，立即透過{{brand}}的手機號碼：{{mobileNum}}享用服務！",

        saveCheckboxTxt: "保存我的手機號碼以便將來以1O1O/csl/Club Sim賬單付款",

        continueBtnTxt: "確定",

        noPackSuccessTitle: "完成!",
        noPackSuccess: "您已完成設定{{brand}}帳戶{{mobileNum}}。",
        noPackBePatient: "你的帳戶沒有訂購Now E計劃或組合。",
        noPackHelpHotline: "需要協助?請致電{{brand}}熱線{{hotLine}}與客戶服務聯絡。",
    }
}

export default tr;
